<template>
  <div class="note-wrapper">
    <v-menu
      v-model="open"
      offset-y
      :close-on-content-click="false"
      transition="scale-transition"
    >
      <!-- Activator -->
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-bind="attrs"
          v-on="on"
          label="Note"
          hide-details
          append-icon="mdi-open-in-new"
          @click:append="open = true"
          :value="displayValue"
          readonly
          @click="open = true"
        />
      </template>

      <!-- Dropdown -->
      <v-card min-width="360">
        <v-list dense>
          <!-- Internal -->
          <v-list-item
            :class="[
              'note-item',
              { 'active-note': currentType === 'internal' },
            ]"
            @click="currentType = 'internal'"
          >
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium">
                {{ $t("scheduler.internal_note") }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ formatNotePreview(localInternal) }}
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action v-if="currentType === 'internal'">
              <v-icon color="white" small>mdi-check</v-icon>
            </v-list-item-action>
          </v-list-item>

          <v-divider />

          <!-- External -->
          <v-list-item
            :class="[
              'note-item',
              { 'active-note': currentType === 'external' },
            ]"
            @click="currentType = 'external'"
          >
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium">
                {{ $t("scheduler.external_note") }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ formatNotePreview(localExternal) }}
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action v-if="currentType === 'external'">
              <v-icon color="white" small>mdi-check</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <v-divider />

        <!-- Editor -->
        <v-card-text>
          <NoteEditor
            :label="
              currentType === 'internal' ? 'Internal note' : 'External note'
            "
            :showLabel="false"
            :translationTarget="translationTarget"
            v-model="editorValue"
            @input="emitChange"
          />
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import NoteEditor from "@/components/NoteEditor.vue";

export default {
  name: "NoteDropdown",

  components: { NoteEditor },

  props: {
    internal_note: String,
    external_note: String,
    translationTarget: [String, Object],
  },

  data() {
    return {
      open: false,
      currentType: "internal",
      localInternal: "",
      localExternal: "",
    };
  },

  computed: {
    displayValue() {
      if (this.localInternal || this.localExternal) {
        console.log("localInternal:", this.localInternal);
        console.log("localExternal:", this.localExternal);
        return this.formatNotePreview(
          this.localInternal || this.localExternal || ""
        );
      }
      return this.$t("note_dropdown_no_content");
    },
    editorValue: {
      get() {
        return this.currentType === "internal"
          ? this.localInternal
          : this.localExternal;
      },
      set(val) {
        if (this.currentType === "internal") {
          this.localInternal = val;
        } else {
          this.localExternal = val;
        }
      },
    },
  },

  watch: {
    internal_note: {
      immediate: true,
      handler(val) {
        this.localInternal = val || "";
      },
    },
    external_note: {
      immediate: true,
      handler(val) {
        this.localExternal = val || "";
      },
    },
  },

  methods: {
    emitChange() {
      this.$emit("update:internal_note", this.localInternal);
      this.$emit("update:external_note", this.localExternal);
    },
    formatNotePreview(note) {
      if (!note) return this.$t("note_dropdown_no_content");

      // Create a detached DOM element (scripts will NOT run)
      const div = document.createElement("div");
      div.innerHTML = note;

      // This strips tags AND decodes entities like &nbsp;
      let text = div.textContent || div.innerText || "";
      text = text.replace(/\u00A0/g, " ").trim(); // replace non-breaking spaces

      if (!text) return this.$t("note_dropdown_no_content");

      return text.length > 70 ? text.substring(0, 70) + "…" : text;
    },
  },
};
</script>

<style scoped>
.note-wrapper {
  width: 100%;
}

.v-list-item-subtitle {
  white-space: normal;
  font-size: 12px;
}

.active-note {
  background-color: #1976d2;
}

.active-note .v-list-item__title,
.active-note .v-list-item__subtitle {
  color: white !important;
  font-weight: 500;
}
</style>
